import React from 'react';

import { Vulnerabilities } from './index';

/** The new vulnerability page selected by new_vuln_dashboard. */
export const VulnerabilityV3Page = () => <Vulnerabilities useVulnerabilityV3 />;
